"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _NewPromotions = _interopRequireDefault(require("./NewPromotions"));
var _NewDiscord = _interopRequireDefault(require("./NewDiscord"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function NewPromotionsWrapper(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "newPromotionsWrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mainPromotionCard"
  }, /*#__PURE__*/_react["default"].createElement(_NewPromotions["default"], {
    i18next: props.i18next,
    promotionalContent: props.promotionalContent
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "discordPromotionCard"
  }, /*#__PURE__*/_react["default"].createElement(_NewDiscord["default"], {
    i18next: props.i18next,
    domain: props.domain
  })));
}
var _default = NewPromotionsWrapper;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/NewPromotionsWrapper.js
 ** module id = 2391
 ** module chunks = 0
 **/